export enum ServiceStatus {
    Approved = "In Progress",
    AwaitingApproval = "Awaiting Approval",
    Archived = "Archived",
    Completed = "Completed",
    Rejected = "Rejected",
    Cancelled = "cancelled",
}